export default {
  init() {
    // JavaScript to be fired on all pages
    jQuery(function() {
      jQuery('.match').matchHeight();
      jQuery('.match-two').matchHeight();
      jQuery('.match-three').matchHeight();
      jQuery('.match-wrap').matchHeight();
      jQuery('.equal').matchHeight({byRow:false});
      jQuery('.equal-two').matchHeight({byRow:false});
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    require('../components/sidenav');
    require('../components/datepicker');
    require('../components/form-labels');
    require('../components/file-upload');
    require('../components/service-cards');
    require('../components/swiper-services');
    require('../components/swiper-usps');
    require('../components/swiper-facilities');
    require('../components/swiper-images');
    require('../components/swiper-specs');
    require('../components/swiper-testimonials');
  },
};
